@if (buscadorOsm()) {
  <div class="buscador-osm">
    <mat-form-field style="width: 100%">
      <mat-label>Buscar territorio en OpenStreetMap</mat-label>
      <input
        matInput
        [formControl]="busquedaOsm"
        placeholder="Ej: Quilmes, Buenos Aires (reemplaza el polígono actual)"
      />
      @if (buscandoOsm) {
        <mat-spinner matSuffix [diameter]="20" />
      } @else {
        <mat-icon matSuffix>search</mat-icon>
      }
    </mat-form-field>

    @if (resultadosOsm.length) {
      <mat-list>
        @for (resultado of resultadosOsm; track resultado.place_id) {
          <mat-list-item
            class="resultado-osm"
            (click)="seleccionarOsm(resultado)"
          >
            <mat-icon matListItemIcon>map</mat-icon>
            <span matListItemTitle>{{ resultado.display_name }}</span>
          </mat-list-item>
        }
      </mat-list>
    }
  </div>
}

<div class="polygon-map-wrap" [style.height]="height()">
  <div #cont class="polygon-map"></div>

  <div class="polygon-tools mat-elevation-z4">
    <button
      type="button"
      mat-icon-button
      class="tool"
      [class.tool-activo]="dibujando"
      [matTooltip]="!dibujando ? 'Dibujar polígono' : 'Cancelar dibujo'"
      (click)="!dibujando ? dibujar() : cancelarDibujo()"
    >
      <mat-icon>{{ !dibujando ? "edit" : "close" }}</mat-icon>
    </button>

    <div class="tool-sep"></div>

    <button
      type="button"
      mat-icon-button
      class="tool tool-danger"
      matTooltip="Eliminar polígono seleccionado"
      (click)="eliminar()"
    >
      <mat-icon>delete_outline</mat-icon>
    </button>

    <button
      type="button"
      mat-icon-button
      class="tool"
      matTooltip="Importar GeoJSON"
      (click)="importar()"
    >
      <mat-icon>upload_file</mat-icon>
    </button>
  </div>
</div>
